function joiMilkCard(prodgirdID) {
  if (!prodgirdID) return $();
  var $cols = $('.jmcs-col').filter(function() { return this.id === prodgirdID; });
  var $visible = $cols.filter(function() { return !$(this).closest('.slick-cloned').length; });
  return $visible.length ? $visible.first() : $cols.first();
}

function updatePricingInterfacep(prodgirdID,totalprice,sub_price,quart) {
  var $col = joiMilkCard(prodgirdID);
  if (!$col.length) return;
  var handle = ($col.attr('data-handle') || '');
  var otpPct = (window.JoiOtpPackDiscount && window.JoiOtpPackDiscount.percentForHandle(handle)) || 0;
  var listCents = Number(totalprice) || 0;
  var subCents = Number(sub_price);
  if (!subCents && listCents) subCents = listCents;
  var otpCents = otpPct ? Math.round(listCents * (100 - otpPct) / 100) : listCents;
  var prodPrice = '$'+( otpCents / 100 ).toFixed(2);
  var prodPriceFull = '$'+( listCents / 100 ).toFixed(2);
  var prodSubPrice = '$'+( subCents / 100).toFixed(2);
  var normal_quart = quart ? '$'+((otpCents / 100) / parseInt(quart, 10)).toFixed(2) +'/quart' : '';
  var sub_quart = quart ? '$'+((subCents / 100) / parseInt(quart, 10)).toFixed(2) +'/quart' : '';
  var otpHtml = otpPct ? ('<s class="prod-compare-price">' + prodPriceFull + '</s> ' + prodPrice) : prodPrice;

  var $freqFake = $col.find('.js-fake-input').first();
  var $freqSel = $col.find('select#interval-selector').first();
  if ($freqFake.length && $freqSel.length && $freqSel.find('option:selected').length) {
    $freqFake.val($freqSel.find('option:selected').text());
  }

  if ( $col.find('input.frequency-selection[value="recurring"]').is(':checked') ) {
    $col.find('select#interval-selector').css('display', 'block');
    $col.find('.double-arrow-select').css('display', 'block');
    $col.find('.prod-reg-price-joi').html(otpHtml);
    $col.find('.prod-sub-price-joi').html(prodSubPrice);
    $col.find('.prod-price-joi').html(prodSubPrice);
    if ($col.find('.quart_price').length) {
      $col.find('.quart_price').html(sub_quart);
    }
    if (!$col.find('.add-to-cart-custom').hasClass('sold-out')) {
    } else {
      $col.find('.quick-add').hide();
    }
  } else {
    $col.find('select#interval-selector').css('display', 'none');
    $col.find('.double-arrow-select').css('display', 'none');
    $col.find('.prod-reg-price-joi').html(otpHtml);
    $col.find('.prod-sub-price-joi').html(prodSubPrice);
    $col.find('.prod-price-joi').html(prodPrice);

    if ($col.find('.quart_price').length) {
      $col.find('.quart_price').html(normal_quart);
    }
    if (!$col.find('.add-to-cart-custom').hasClass('sold-out')) {
    } else {
      $col.find('.quick-add').hide();
    }
  }
}

$( document ).ready(function() {
  $('.jmcs-col').each(function(i,v) {
    if ($(this).closest('.slick-cloned').length) return;
    var id = $(v).attr('id');
    var price = $(this).attr('data-price');
    var sub_price = $(this).attr('data-sub-price');
    var quart = $(this).attr('data-quart');

    updatePricingInterfacep(id,price,sub_price,quart);
  });

  //---Quickview Handlers---

  //handle the change of quantity
  $('body').on('change', 'input.quantity-selection', function() {
    var id = $(this).closest('.jmcs-col').attr('id');
    var price = $(this).closest('.jmcs-col').attr('data-price');
    var sub_price = $(this).closest('.jmcs-col').attr('data-sub-price');
    var quart = $(this).closest('.jmcs-col').attr('data-quart');
    updatePricingInterfacep(id,price,sub_price,quart);
  });

  //handle the change of recurring
  $('body').on('change', '.jmcs-col select#interval-selector, .jmcs-col .js-select', function() {
    var $col = $(this).closest('.jmcs-col');
    var $fake = $col.find('.js-fake-input').first();
    var opt = $(this).find('option:selected');
    if ($fake.length && opt.length) $fake.val(opt.text());
  });

  $('body').on('change', 'input.frequency-selection', function() {
    var id = $(this).closest('.jmcs-col').attr('id');
    $(this).parents('.control-group').find('label').removeClass('active-checked');
    if ($(this).is(':checked')) {
      $(this).parent().addClass('active-checked');
    }
    var price = $(this).closest('.jmcs-col').attr('data-price');
    var sub_price = $(this).closest('.jmcs-col').attr('data-sub-price');
    var quart = $(this).closest('.jmcs-col').attr('data-quart');
    updatePricingInterfacep(id,price,sub_price,quart);
    if($(this).val() == 'one-time'){
      $(this).closest('.product-detail-sec').find('.pack-sizes-wrp').removeClass('subscription-active');
    }else{
      $(this).closest('.product-detail-sec').find('.pack-sizes-wrp').addClass('subscription-active');
    }
    
  });

  //handle click of quantity increase/decrease
  $('body').on('click', 'quantity-selection-button', function(e) {
    var quickviewID = $(this).parent().attr('data-quickviewID');
    var curVal = parseInt($('input#quantity-selection-' + quickviewID).val());
    console.log(quickviewID);
    console.log(curVal);

    if ( $(this).hasClass("minus") ) {
      if (curVal != 1 ) {
        $('input#quantity-selection-' + quickviewID).val(curVal - 1);
        $('input#quantity-selection-' + quickviewID).change();
      } 
    } else if ($(this).hasClass("plus")) {
      $('input#quantity-selection-' + quickviewID).val(curVal + 1);
      $('input#quantity-selection-' + quickviewID).change();
    }
  })

  //handle the add to cart
  $('body').on('click', '.add-to-cart-custom', function(e) {
    var __this = $(this);
    if (!$(this).hasClass('sold-out') && !$(this).hasClass('disabled')) {
      var prodgirdID = $(this).attr('data-prodgirdID');
      var $card = $(this).closest('.jmcs-col');
      if (!$card.length) $card = joiMilkCard(prodgirdID);
      var id = $card.attr('data-variant-id');
      var qty = $card.attr('data-qty');
      var selling_plan_id = $card.find('select#interval-selector').children("option:selected").val();
      
      if ($card.find('select#interval-selector').length > 0) {
        var ship_freq = $card.find('select#interval-selector').children("option:selected").attr('data-ship').replace('(s)', 's');
      }
      console.log('id===',id);
      console.log('selling_plan_id==',selling_plan_id);
      console.log('ship_freq ==',ship_freq);
      function callback() {
        setTimeout(function() {
          __this.removeClass( "validate" );
          if (__this.hasClass('redirect_checkout')) {
            setTimeout(function() {
              window.location.href='/checkout';
            }, 2000);
          }
          else {  
            console.log(1233333);
            toggleCart();
          }
        }, 500);
      }
      function validate() {
        setTimeout(function() {
          __this.removeClass( "onclic" );
          __this.addClass("validate");
          callback()
        }, 1100);
      }
      __this.addClass("onclic");
      validate();
      if ($card.find('input.frequency-selection[value="recurring"]').is(':checked') || $card.find('select#interval-selector[data-subs-only]').length) {

        //determine the right interval to use

        var viewData = { 
          items : []
        };
        if ($(this).attr('data-bundleprimaryid') != null){
          const primaryProductId = $(this).attr('data-bundleprimaryid');
          const bonusProductId = $(this).attr('data-bundlebonusid');
          const bonusProductPrice = $(this).attr('data-bundlebonusprice');
          const bundleDiscount = $(this).attr('data-bundlediscount');
          const bundleName = $(this).attr('data-bundlename');
          const primaryProductPrice = $(this).attr('data-bundleprimaryprice');
          const bundleUrl = $(this).attr('data-bundleurl');
          console.log("IT's GOING DOWN");
          var primaryData = {};
          var bonusData = {};

          primaryData['quantity'] = parseInt(qty);
          primaryData['id'] = primaryProductId;
          primaryData['selling_plan'] = selling_plan_id;
          primaryData['properties'] = {
            "_recurring": "true",
            "Interval Unit": "week",
            "Subscription": ship_freq,
            "Recurring Discount Amount": "18%",
            "Bundle": bundleName,
            "_bundle_url": bundleUrl,
            "_primary_product_price": primaryProductPrice,
            "_bundle_discount": "5"
          }
          bonusData['quantity'] = parseInt(qty);
          bonusData['id'] = bonusProductId;
          bonusData['properties'] = {
            "Bundle": bundleName,
            "_bonus_product_price": bonusProductPrice,
            "_bundle_discount": bundleDiscount,
            "_bundle_url": bundleUrl,
          }
          viewData.items.push(primaryData);
          viewData.items.push(bonusData);
        } else if ($card.attr('data-preorder') == "true") {
          var jsonData = {};
          jsonData['quantity'] = qty;
          jsonData['id'] = id;
          jsonData['selling_plan'] = selling_plan_id;
          jsonData['properties'] = {
            "_preorder": "Ships when available",
            "_recurring": "true",
            "Interval Unit": "week",
            "Recurring Discount Amount": "18%",
            "Subscription": ship_freq
          }
          viewData.items.push(jsonData);
        } else {
          var jsonData = {};
          jsonData['quantity'] = qty;
          jsonData['id'] = id;
          jsonData['selling_plan'] = selling_plan_id;
          jsonData['properties'] = {
            "_recurring": "true",
            "Interval Unit": "week",
            "Recurring Discount Amount": "18%",
            "Subscription": ship_freq
          }
          viewData.items.push(jsonData);
        }
        console.log(viewData['items']);
        CartJS.addItem({items : viewData['items']}, '', null);
      } else {
        if ($card.attr('data-preorder') == "true") {
          //Add to cart
          CartJS.addItem(
            id, 
            parseInt(qty),
            {
              "_preorder": "Ships when available"
            }
          );
        } else {
          //Add to cart
          CartJS.addItem(
            id, 
            parseInt(qty)
          );

        }
      }
      //open the cart
//       if (!$('input[name="frequency-selection-' + prodgirdID + '"][value="recurring"]').is(':checked')) {
//         toggleCart();
//       }

      //fire taboola script
      _tfa.push({notify: 'event', name: 'Add_to_Bag', id: 1345707});
    }
  });
});
